module.exports = __webpack_public_path__ + "static/media/satellite.bb06a53e.svg";